import { useState, useEffect } from 'react'
import React from 'react';
import { useParams } from 'react-router-dom';
import '../styles/App.css';
import Input from './InputItem.js';
import Grille from './GrilleItem.js';
import Countdown from './Countdown.js';
import Prev from './Prev.js';
import Rules from './Rules.js';
import Nav from './Nav.js';
const URL_BACKEND = process.env.REACT_APP_URL_BACKEND;


function ItemsMode() {

  const gameMode = 'item'
  const { id } = useParams(); // undefined si route /item (puzzle du jour)
  const isArchive = !!id;

  var dateDuJour = new Date();
  var annee = dateDuJour.getFullYear();
  var mois = (dateDuJour.getMonth() + 1).toString().padStart(2, '0');
  var jour = dateDuJour.getDate().toString().padStart(2, '0');
  var dateFormatee = `${annee}-${mois}-${jour}`;

  const [itemFind, setitemFind] = useState(0);
  const [itemNow, setItemNow] = useState([]);

  // Clé localStorage distincte pour le mode archive (par id), pour ne pas
  // écraser la progression du puzzle du jour
  const storageKey = isArchive ? `rows-item-archive-${id}` : 'rows-item';

  const savedrowsLocal = localStorage.getItem(storageKey)
  let savedrows = null;
  if (savedrowsLocal) {
    savedrows = isArchive
      ? JSON.parse(savedrowsLocal) // en archive, pas de filtre par date : toute la partie appartient à ce puzzle
      : JSON.parse(savedrowsLocal).filter(row => row.dateFormatee === dateFormatee && row.gameMode === gameMode);
  }

  const [nbTest, nbTestUpdate] = useState(savedrows ? savedrows.length : 0)
  const [nbTestMax, nbTestMaxUpdate] = useState(nbTest === 10 ? 1 : 0)

  // Initialiser itemNow avec le puzzle du jour OU le puzzle archivé
  useEffect(() => {
    const fetchItem = async () => {
      try {
        const url = isArchive
          ? `${URL_BACKEND}/api/history/item/${id}`
          : `${URL_BACKEND}/api/items-now`;
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log('Data item fetched successfully:', data);
        setItemNow(data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchItem();
  }, [id, isArchive]);

  const [rows, rowsUpdate] = useState(savedrows ? savedrows : [])

  useEffect(() => {
    if (itemNow.length === 0) {
      return;
    }
    localStorage.setItem(storageKey, JSON.stringify(rows))

    nbTestUpdate(rows.length)
    rows.length === 10 ? nbTestMaxUpdate(1) : nbTestMaxUpdate(0)

    if (rows.length > 0 && rows[0].id === itemNow.id_item) { setitemFind(1) } else { setitemFind(0) }

  }, [rows, itemNow])

  return (
    <div>
      <Nav />
      <Input
        gameMode={gameMode}
        rows={rows}
        rowsUpdate={rowsUpdate}
        itemNow={itemNow}
        setItemNow={setItemNow}
        itemFind={itemFind}
        nbTestMax={nbTestMax}
        nbTest={nbTest}
        dateFormatee={isArchive ? itemNow.date_historique : dateFormatee}
      />
      {!isArchive && (nbTestMax === 1 || itemFind === 1) ?
        <Countdown />
        : null
      }
      <Grille
        gameMode={gameMode}
        rows={rows}
        rowsUpdate={rowsUpdate}
        itemNow={itemNow}
        setItemNow={setItemNow}
        dateFormatee={isArchive ? itemNow.date_historique : dateFormatee}
      />
      {!isArchive && <Prev gameMode={gameMode} />}
      <Rules gameMode={gameMode} />
    </div>
  )
}

export default ItemsMode